import uuid from 'uuid/v1'
import timestamper from '../timestamper'
import { db } from '../../config/firebaseconfig'
import queryString from 'query-string'
import getRequest from '../getRequest'

export default function addUser(state, updateState, role, props, cancel) {
  const orgCollection = {
    'Teacher': 'schools',
    'School Admin': 'schools',
    'District Admin': 'districts',
    'Student': 'schools',
  }
  const keyName = {
    'Teacher': 'teachers',
    'School Admin': 'admins',
    'District Admin': 'admins',
    'Student': 'students',
  }
  const userCollection = {
    'Teacher': 'educators',
    'School Admin': 'educators',
    'District Admin': 'educators',
    'Student': 'students',
  }

  updateState({isSaving: true})

  function errorHandling(state) {
    let error = ''
    if (!state.firstName) {
      error = 'First name field is required.'
    } else if (!state.lastName) {
      error = 'Last name field is required.'
    } else if (!state.email && role !== 'Student') {
      error = 'Email is required.'
    } else if (state.manualAdd && !state.password) {
      error = 'Password is required.'
    } else if (role === 'Student' && state.manualAdd && !state.username && !state.email) {
      error = 'Username is required.'
    } else if (role === 'Student' && !state.email && !state.manualAdd) {
      error = 'Email is required.'
    }
    if (state.email) {
      const checkAt = state.email.search('@') === -1
      const checkDot = state.email.search('.') === -1
      if (checkAt || checkDot) {
        error = 'Email invalid.'
      }
    }
    return error
  }

  let error = errorHandling(state)
  if (error) {
    updateState({isSaving: false, error})
  } else {
    const id = uuid()
    const inviteId = uuid()
    const time = timestamper()
    let org
    if (role === 'District Admin') {
      org = props.districts[props.selectedDistrict]
    } else {
      org = props.schools[props.selectedSchool]
    }
    const batch = db.batch()
    const userRef = db.collection(userCollection[role]).doc(id)
    const orgRef = db.collection(orgCollection[role]).doc(org.id) 
    const inviteRef = db.collection('userInvites').doc(inviteId)

    const fullName = `${state.firstName} ${state.lastName}`
    let userData = {
      id,
      email: state.email,
      username: state.email,
      firstName: state.firstName,
      lastName: state.lastName,
      fullName,
      state: org.state,
      lastModified: time,
      created: time,
      role,
      isTeacher: role === 'Teacher',
      sfid: state.sfid ? state.sfid : '',
      validated: state.manualAdd,
    }
    if (role === 'Teacher' || role === 'Student') {
      userData.classes = {}
    }
    if (role === 'District Admin') {
      userData.schoolDistrict = org.id
    } else if (role === 'School Admin' || role === 'Teacher' || role === 'Student') {
      userData.schoolDistrict = org.district
      userData.school = org.id
    }
    if (role === 'Student') {
      userData.assessments = {}
      userData.username = state.username
    } else {
      userData.username = state.email
    }

    batch.set(userRef, userData)       

    const key = `${keyName[role]}.${id}`
    batch.update(orgRef, {[key]: true})      

    if (!state.manualAdd) {
      batch.set(inviteRef, {
        id: inviteId,
        userId: id,
        createdDate: time,
        expirationDate: (time + 259200000), 
        firstName: state.firstName,
        lastName: state.lastName,
        email: state.email,
      })
    }

    let dupQuery
    if (role !== 'Student') {
      dupQuery = queryString.stringify({
        email: state.email,
      })
    } else {
      let dupQ = {}
      if (state.email) {
        dupQ.email = state.email
      }
      if (state.username) {
        dupQ.username = state.username
      }
      if (userData.schoolDistrict) dupQ.schoolDistrict = userData.schoolDistrict
      dupQuery = queryString.stringify(dupQ)
    }

    let checkDupUrl = `https://us-central1-bellwork-cg1.cloudfunctions.net/checkEducatorsEmailDuplication?${dupQuery}`
    if (role === 'Student') {
      checkDupUrl = `https://us-central1-bellwork-cg1.cloudfunctions.net/checkStudentsEmailDuplication?${dupQuery}`
    }
    getRequest(checkDupUrl)
      .then((response) => {
        if (JSON.parse(response).error) {
          throw JSON.parse(response).error
        } else {
          if (state.manualAdd) {
            const data = {
              id,
              password: state.password,
            }
            const query = queryString.stringify(data)
            let url = `https://us-central1-bellwork-cg1.cloudfunctions.net/manualAddEducator?${query}`
            if (role === 'Student') {
              url = `https://us-central1-bellwork-cg1.cloudfunctions.net/manualAddStudent?${query}`
            }
            return getRequest(url)
          } else {
            return Promise.resolve()
          }
        }
      })
      .then(() => batch.commit())
      .then(() => cancel(id))
      .catch((err) => {
        console.log('addUser error', err)
        updateState({error: err, isSaving: false})
      })
  }
}


// WEBPACK FOOTER //
// ./src/helpers/users/addUser.js